export default __webpack_public_path__ + "static/media/BoomFullyDeployed.8d7366e9.MOV";